import { Route, mapToCanActivate } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RouterFragments } from '@core/model/RouterFragments';

export default [
  {
    path: `:tenantId/auth-dashboard/${RouterFragments.UNKNOWN}`,
    loadChildren: () => import('@pages/auth-detail-not-found/auth-detail-not-found.module')
      .then((m) => m.AuthDetailNotFoundModule),
    title: 'Auth Details Not Found',
    canActivate: mapToCanActivate([MsalGuard]),
  }
] as Route[];
